import { styled } from "styled-components";
import { useIntl } from "react-intl";
import type { LegacyTableProps } from "@wayflyer/flyui-dataviz";
import { LegacyTable } from "@wayflyer/flyui-dataviz";
import { MarkDown } from "@wayflyer/flyui";

import { TabTitle } from "../../../../components/tab-title";
import { Spacer } from "../../../../components/shared";

export interface ConsumersLtvTabProps {
  summaryText?: string;
  table: LegacyTableProps;
  title: string;
  tooltip?: string;
}

const ScrollContainer = styled.div`
  overflow-x: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: start;
  }
`;
const Container = styled.div``;

interface SpacerProps {
  margin?: string;
  maxWidth?: string;
}

const StyledSpacer = styled.span<SpacerProps>`
  ${(props) => (props.margin ? `margin-left: ${props.margin};` : "")}
  ${(props) => (props.maxWidth ? `max-width: ${props.maxWidth};` : "")}
`;

const LegendFooter = styled.div`
  display: grid;
  grid-auto-flow: column;
  max-height: 50px;
  max-width: 900px;
  padding-bottom: 5px;
`;

const LegendElement = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 10px;
`;

const LTVLegend = (title): UIElement => {
  const intl = useIntl();
  return (
    <Container>
      <StyledSpacer maxWidth="100px" />
      <LegendFooter>
        <StyledSpacer margin="50px" maxWidth="50px" />
        <LegendElement>
          {intl.formatMessage({ id: "Consumers LTV Tab: Legend Lower value", defaultMessage: "Lower value" })}
          <div
            style={{
              marginLeft: "5px",
              marginRight: "5px",
              minWidth: "135px",
              height: "20px",
              backgroundColor: "orange",
              background: "linear-gradient(90deg, #6EE7B7 0%, #34D399 31.67%, #10B981 65.56%, #047857 101.11%)",
            }}
          />
          {intl.formatMessage({ id: "Consumers LTV Tab: Legend Higher value", defaultMessage: "Higher value" })}
        </LegendElement>
        <StyledSpacer margin="50px" maxWidth="50px" />
        <LegendElement>
          <div
            style={{
              marginLeft: "5px",
              marginRight: "5px",
              width: "30px",
              height: "20px",
              backgroundColor: "orange",
              background: "#F59E0B",
            }}
          />
          {intl.formatMessage({
            id: "Consumers LTV Tab: CAC exceeds Customer value",
            defaultMessage: "CAC exceeds Customer value",
          })}
        </LegendElement>
        <StyledSpacer margin="50px" maxWidth="50px" />
        {title ? title.title : null}
      </LegendFooter>
    </Container>
  );
};

/**
 * ConsumersLtvTab component
 */
export const ConsumersLtvTab = ({ summaryText, table, title, tooltip }: ConsumersLtvTabProps): UIElement => {
  const TableCont = styled.div`
    display: flex;
    width: 100%;
    margin-top: ${table.title && table.title !== "" ? 0 : 25}px;
    @media (max-width: 768px) {
      margin-top: 0;
    }

    th,
    td {
      width: 75px;
      box-sizing: content-box;
    }

    & .ConsumersLtvTable {
      width: 100%;
      table {
        table-layout: fixed;
        width: 100%;
      }
    }
  `;
  return (
    <>
      <TabTitle title={title} tooltip={tooltip} />
      {summaryText ? <MarkDown markdown={summaryText} /> : null}
      <Spacer />
      <div>
        <ScrollContainer>
          <Spacer />
          <TableCont>
            <LegacyTable
              {...{
                ...table,
                className: "ConsumersLtvTable",
              }}
            />
          </TableCont>
        </ScrollContainer>
        <Spacer />
        <LTVLegend />
      </div>
    </>
  );
};
